
import { useEffect } from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import Highlights from'../Component/Highlights' 
const Header = () => {
  const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
  return (
        <> 
        <div className="header"> 
        <div className="logo">
            <NavLink to="/"><img src="https://webapi.entab.info/api/image/SHCSKWB/public/Images/logo.png" alt="SHCSKWB" className="img-fluid"/></NavLink>
        </div>
        <div className="header-nav">
        <Highlights/>
            <nav className="navbar navbar-expand-lg">
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#main_nav">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="main_nav">
                <ul className="navbar-nav"> 
                <li className="nav-item"><NavLink className="dropdown-item" to="/"> Home </NavLink></li>  
                     <li className="nav-item dropdown"> 
                       <div className="nav-link" data-bs-toggle="dropdown">  About Us <i class="bi bi-caret-down-fill"></i></div> 
                           <ul className="dropdown-menu fade-up"> 
                                <li><NavLink  className="dropdown-item" to="/PrincipalMessage">Principal Message</NavLink></li> 
                           </ul>   
                    </li> 
                    <li className="nav-item dropdown">
                      <div className="nav-link" data-bs-toggle="dropdown"><NavLink  className="dropdown-item" to="/">Academic <i class="bi bi-caret-down-fill"></i></NavLink></div>  
                          <ul className="dropdown-menu fade-up">
                          <li><NavLink  className="dropdown-item" to="/Library">Library</NavLink></li>
                            <li><NavLink  className="dropdown-item" to="/Examination">Examination</NavLink></li>
                            <li><NavLink  className="dropdown-item" to="/Uniform">Uniform</NavLink></li>
                            <li><NavLink  className="dropdown-item" to="/Withdrawals">Withdrawals </NavLink></li>
                            <li><NavLink  className="dropdown-item" to="/Junior/Curriculum">Curriculum</NavLink></li>
                            <li><NavLink  className="dropdown-item" to="/Junior/Attendance">Attendance</NavLink></li> 
                            <li><NavLink  className="dropdown-item" to="/Junior/SchoolHours">School Hours</NavLink></li> 
                            <li><NavLink  className="dropdown-item" to="/Junior/Fees">Fees</NavLink></li> 
                            {/*<li><NavLink  className="dropdown-item" to="/Admission">Admission</NavLink></li>   */}
                        </ul>  
                    </li> 
                    <li className="nav-item dropdown"> 
                      <div className="nav-link" data-bs-toggle="dropdown"><NavLink  className="dropdown-item" to="/"> Admission <i class="bi bi-caret-down-fill"></i></NavLink></div>  
                           <ul className="dropdown-menu fade-up">
                            <li> <NavLink className="dropdown-item" to="/Junior/Admission">Admission </NavLink></li> 
                        </ul>  
                    </li>  
                    <li className="nav-item dropdown"> 
                      <div className="nav-link" data-bs-toggle="dropdown"><NavLink  className="dropdown-item" to="/">Gallery <i class="bi bi-caret-down-fill"></i></NavLink></div>  
                            <ul className="dropdown-menu fade-up">
                            <li> <NavLink className="dropdown-item" to="/Gallery"> Gallery</NavLink></li> 
                            <li> <NavLink className="dropdown-item" to="/VideoGallery">Video Gallery</NavLink></li> 
                             
                        </ul>  
                    </li>   
                    <li className="nav-item"><NavLink className="dropdown-item" target="_blank" to="#">  Online Payment </NavLink></li>  
                     
                    <li className="nav-item"><NavLink className="dropdown-item" to="/ContactUs"> Contact Us </NavLink></li>  
               
                </ul>
                </div> 
           </nav>
        </div> 
    </div>
    </>
  )
}

export default Header
